import React from "react";
import { useNavigate } from "react-router-dom";
import ProductDetailsView from "./productDetailsView";
import RefactoredEditProduct from "./components/RefactoredEditProduct";

const DynamicTab = ({ 
  tabData, 
  onSuccess, 
  onCancel, 
  onClose, 
  activeTabKey 
}) => {
  console.log('DynamicTab rendering with tabData:', tabData);
  const navigate = useNavigate();
  
  if (!tabData) {
    return <div>No tab data provided</div>;
  }
  
  const handleClose = () => {
    console.log('Tab closing:', tabData.key);
    // Navigate back to the product list when closing a tab
    navigate('/products/list');
    
    if (onSuccess) {
      onSuccess();
    }
    if (onClose) {
      onClose(tabData.key);
    }
  };


  const renderTabContent = () => {
    switch (tabData.type) {
      case 'add-product': {
        console.log('Rendering add-product tab with clientId:', tabData.clientId);
        return (
          <div className="content" style={{ padding: "20px" }}>
            <RefactoredEditProduct
              productId={null}
              clientId={tabData.clientId}
              onSuccess={handleClose}
              onCancel={handleClose}
              {...tabData.props}
            />
          </div>
        );
      }
      
      case 'edit-product': {
        console.log('Rendering edit-product tab with productId:', tabData.productId, 'clientId:', tabData.clientId);
        return (
          <div className="content" style={{ padding: "20px" }}>
            <RefactoredEditProduct
              productId={tabData.productId}
              clientId={tabData.clientId}
              onSuccess={handleClose}
              onCancel={handleClose}
              {...tabData.props}
            />
          </div>
        );
      }

      case 'view-product': {
        return (
          <ProductDetailsView
            isVisible={true}
            onClose={handleClose}
            productId={tabData.productId}
            editMode={false}
            onResize={() => { /* no-op */ }}
            toggleEdit={() => { /* no-op */ }}
            setProductId={() => { /* no-op */ }}
            clientId={tabData.clientId}
            variationId={tabData.variationId}
            setVariationId={() => { /* no-op */ }}
            warehouseId={tabData.warehouseId}
            fetchProducts={handleClose}
            {...tabData.props}
          />
        );
      }
      
      default: {
        return (
          <div className="content" style={{ padding: "20px" }}>
            <h4>Unknown tab type: {tabData.type}</h4>
          </div>
        );
      }
    }
  };

  return (
    <div className="dynamic-tab-wrapper">
      {renderTabContent()}
    </div>
  );
};

export const createTabConfig = (type, options = {}) => {
  // Create meaningful key based on type and data to prevent duplicates
  const keyComponents = [type];
  if (options.productId) keyComponents.push(options.productId);
  if (options.variationId && options.variationId !== 'null') keyComponents.push(options.variationId);
  if (options.warehouseId && options.warehouseId !== 'null') keyComponents.push(options.warehouseId);
  if (options.clientId) keyComponents.push(options.clientId);
  
  const key = keyComponents.join('-');
  
  return {
    key: key,
    closable: true,
    title: options.title || type.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()),
    data: {
      type: type,
      clientId: options.clientId || null,
      productId: options.productId || null,
      variationId: options.variationId || null,
      warehouseId: options.warehouseId || null,
      component: options.component || null,
      props: options.props || {},
      ...options
    }
  };
};

export default DynamicTab;